
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/ocpp",
      function () {
        return require("private-next-pages/evcharging/ocpp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/ocpp"])
      });
    }
  